import React, { useState } from "react";
import { Table } from "reactstrap";
import CustomPagination from "./CustomPagination";

const CommonTable = ({
  columns,
  data,
  defaultPageSize = 10,
  showPaginationBottom = true,
  activePage = 1,
  setPageNum,
  totalPages = 0,
  rowClick,
  className = "",
  rowClassName,
  expandedRowIndex,
  renderExpandedRow,
}) => {
  const totalMinWidth = columns.reduce(
    (sum, col) => sum + (col.minWidth || 100),
    0,
  );
  return (
    <>
      {/* ---------- reactstrap table ---------- */}
      <Table responsive hover className={className}>
        {/* ---------- header ---------- */}
        <thead className="table-thead">
          <tr>
            {columns.map((column) => (
              <th
                key={column.accessor || column.id}
                className={column.className || "align-top"}
                style={{
                  minWidth: column.minWidth,
                }}
              >
                {column.Header}
              </th>
            ))}
          </tr>
        </thead>

        {/* ---------- body ---------- */}
        <tbody>
          {data.length > 0 ? (
            data.map((row, rowIndex) => {
              const isExpanded = expandedRowIndex === row.id;
              return (
                <React.Fragment key={rowIndex}>
                  <tr
                    key={rowIndex}
                    style={{
                      cursor:
                        !renderExpandedRow && rowClick ? "pointer" : "default",
                    }}
                    onClick={() => rowClick?.(row)}
                    className={
                      rowClassName
                        ? rowClassName({ ...row, index: rowIndex, isExpanded })
                        : ""
                    }
                  >
                    {columns.map((column) => (
                      <td
                        key={column.accessor || column.id}
                        style={{
                          minWidth: column.minWidth,
                        }}
                      >
                        {column.Cell
                          ? column.Cell({
                              value: row[column.accessor],
                              row: { original: row },
                              isExpanded,
                            })
                          : (row[column.accessor] ?? "-")}
                      </td>
                    ))}
                  </tr>

                  {isExpanded && renderExpandedRow && (
                    <tr>
                      <td
                        colSpan={columns.length}
                        className={`${isExpanded && renderExpandedRow ? "p-3" : "p-0"}`}
                      >
                        {renderExpandedRow(row)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center py-4">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* ---------- pagination ---------- */}
      {showPaginationBottom && totalPages > 1 && (
        <CustomPagination
          totalPages={totalPages}
          activePage={activePage}
          setPageNum={setPageNum}
        />
      )}
    </>
  );
};

export default CommonTable;
